export default __webpack_public_path__ + "static/media/Organ.d5ae198a.mp3";